import { render, staticRenderFns } from "./ticket-astrict-user.vue?vue&type=template&id=c66fd7d2&scoped=true&"
import script from "./ticket-astrict-user.vue?vue&type=script&lang=js&"
export * from "./ticket-astrict-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66fd7d2",
  null
  
)

export default component.exports